import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningDialogComponent implements OnInit {
  content: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WarningDialogComponent>
  ) {}

  ngOnInit(): void {
    this.content = this.data.content;
  }

  onDismiss(): void {
    this.dialogRef.close();
  }
}
